import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { Table } from "../../../../component/table/Table";
import { inventorySparesLotListTableColumnsConfig } from "./inventorySparesLotListTableColumnDef";
import classes from "./inventorySparesLotListTablePage.module.css";

export const InventorySparesLotListTablePage = ({
  data,
  inventoryId,
  hasMore,
  onLoadMore,
  isFetchingMore, // new prop to indicate loading
}) => {
  const navigate = useNavigate();
  const bottomRef = useRef(null);

  /* ---------- Intersection Observer for infinite scroll ---------- */
  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onLoadMore();
        }
      },
      {
        root: null,
        rootMargin: "200px", // triggers load earlier than exact bottom
        threshold: 0.1,
      }
    );

    if (bottomRef.current) observer.observe(bottomRef.current);

    return () => observer.disconnect();
  }, [hasMore, onLoadMore]);

  /* ---------- Handlers for table actions ---------- */
  const handleNavigateToLotDetail = useCallback(
    (lotItemId) => {
      navigate(`/inventory/spares/${inventoryId}/${lotItemId}`);
      console.log(lotItemId)
    },
    [inventoryId, navigate]
  );

  /* ---------- Build columns once ---------- */
  const columnDefs = useMemo(
    () => inventorySparesLotListTableColumnsConfig(handleNavigateToLotDetail),
    [handleNavigateToLotDetail]
  );

  return (
    <>
      <Table data={data} columns={columnDefs} />

      {/* Infinite scroll loader / end message */}
      <div ref={bottomRef} className={classes.loaderContainer}>
        {isFetchingMore ? (
          <div className={classes.spinner}></div>
        ) : !hasMore && data.length > 0 ? (
          <div className={classes.endMessage}>All lots loaded</div>
        ) : null}
      </div>
    </>
  );
};
